//系统标签
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

import imgRed from "./red.png";
import imgGreen from "./green.png";

export default observer(({ data, className }) => {
  const t = useTranslation();
  const { finance } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const isGreen = data.type === "green";
    const convertData = {
      label: data.label,
      img: isGreen ? imgGreen : imgRed,
      cls: isGreen ? styles.tagGreen : styles.tagRed,
    };
    return convertData;
  }, [data]);

  return (
    <div className={cx(styles.main, selfData.cls, className)}>
      <img src={selfData.img} />
      <div>{selfData.label}</div>
      <span></span>
    </div>
  );
});
